import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-edit-encoder',
  templateUrl: './admin-edit-encoder.component.html',
  styleUrls: ['./admin-edit-encoder.component.scss']
})
export class AdminEditEncoderComponent implements OnInit, AfterViewInit {
  form = new FormGroup({});
  model = { name: '', newLineSequence: '', startSequence: '', clearSequence: '' };
  fields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'row mt-5',
      fieldGroup: [
        {
          key: 'name',
          type: 'input',
          templateOptions: {
            label: 'Name'
          },
          name: 'Name'
        },
        {
          key: 'startSequence',
          type: 'input',
          templateOptions: {
            label: 'Start Sequence'
          },

          name: 'Start Sequence'
        },
        {
          key: 'newLineSequence',
          type: 'input',
          templateOptions: {
            label: 'New Line Sequence'
          },
          name: 'New Line Sequence'
        },
        {
          key: 'clearSequence',
          type: 'input',
          templateOptions: {
            label: 'Clear Sequence'
          },
          name: 'Clear Sequence'
        },
        {
          key: 'maxCharactersPerLine',
          type: 'input',
          templateOptions: {
            type: "number",
            label: 'Max characters per line'
          },
          name: 'Max characters per line'
        }
      ]
    }
  ];

  constructor(private ref: MatDialogRef<AdminEditEncoderComponent>, @Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit(): void {}

  submit() {
    const {maxCharactersPerLine} = this.form.value;

    if(maxCharactersPerLine){
      this.form.value.maxCharactersPerLine = Number(maxCharactersPerLine);
    }
    this.ref.close(this.form.value);
  }

  ngAfterViewInit(): void {
    this.form.patchValue({ ...this.data.encoder });
  }
}
